import { CSV_HEADERS } from '../config/jobConstants';

// Export jobs to CSV
export const exportToCSV = (jobs) => {
  const csvData = jobs.map(job => [
    job.category_name || '',
    job.customer_name || '',
    job.service_type || '',
    job.status || '',
    job.scheduled_date ? new Date(job.scheduled_date).toLocaleString() : '',
    job.technician_name || '',
    job.price || '',
    job.estimated_duration || '',
    job.actual_duration || '',
    job.created_at ? new Date(job.created_at).toLocaleDateString() : ''
  ]);

  const csvContent = [CSV_HEADERS, ...csvData]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  return csvContent;
};

// Download CSV file
export const downloadCSV = (jobs, filename = 'jobs.csv') => {
  const csvContent = exportToCSV(jobs);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};